import { compose, withHandlers, withState } from "recompose"
import QuizPanel from "./QuizPanel"

// export const handleSelectAnswer = ({
//   question: { answers }, 
//   onAnswerSelected, 
//   setSelectedAnswerIndex
// }) => answerIndex => () => {
//   setSelectedAnswerIndex(answerIndex)
//   onAnswerSelected(answers[answerIndex].text)
// }

QuizPanel.defaultProps = {
  colors: {
    correctBackground: "#6cd379",
    correctForeground: "#2DB5AB",
    highlight: "#EC8B1C",
    primary: "#101733",
    primaryFont: "#ffffff",
    timerBackground: "#4f4f4f",
    variables: "#1FA7DF",
    wrongBackground: "#ea116f",
    wrongForeground: "#BC0F62",
  },
  countdown: {
    startTime: 23000,
    timeRemaining: 21000,
  },
  isRevealed: false,
  question: {
    answers: [
      {
        correct: false,
        percentAnsweredThis: 20,
        percentTotalPointsUsed: 0,
        selectedBy: 2,
        text: "Arbys",
        totalPointsUsed: 0
      },
      {
        correct: false,
        percentAnsweredThis: 50,
        percentTotalPointsUsed: 0,
        selectedBy: 5,
        text: "McDonalds",
        totalPointsUsed: 0
      },
      {
        correct: true,
        percentAnsweredThis: 30,
        percentTotalPointsUsed: 0,
        selectedBy: 3,
        text: "WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW",
        totalPointsUsed: 0
      },
      {
        correct: false,
        percentAnsweredThis: 10,
        percentTotalPointsUsed: 0,
        selectedBy: 1,
        text: "This is a 50 character limit and how it looks like",
        totalPointsUsed: 0
      }
    ],
    text: "This question in its entirety adds up to just about 150 individual characters in order to show our maximum character limit in action, how does it look?"
  },
  score: 14768,
}

export default compose(
  withState("selectedAnswerIndex", "setSelectedAnswerIndex", null),
  // withHandlers({
  //   handleSelectAnswer
  // })
)(QuizPanel)